module.exports = __webpack_public_path__ + "static/media/flipHorizontal.7d13059e.svg";